// extracted by mini-css-extract-plugin
module.exports = {"heading":"TermsOfServicePage_heading__DOlgl","content":"TermsOfServicePage_content__7YT3y"};